import React from "react";
import BarraSupDent from "../../commons/NavUp";
import Title from "../Login/Components/title/title";
import "./Time_confirmation.css";
import firebaseManager from '../../model/Firebase/FirebaseManager'

class Time_confirmation extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        ele.classList.add("available");
        setTimeout(() => {
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }
  constructor() {
      super()
      this.getDataDent = this.getDataDent.bind(this)
      this.state = {
          time_repair: ''
      }
      this.getDataDent()
  }

  getDataDent() {
      firebaseManager.dentInProgress(this.successData)
  }

  successData = (data) => {
    this.setState({
        time_repair: data.SelectedTimeRepair
    })
  }

  confirmDent = () => {
    firebaseManager.confirmDent(this.successConfirm, this.failConfirm);
  };

  successConfirm = () => {
    window.location = "/home";
  };

  failConfirm(error) {
    alert(error.mesagge);
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <Title text1="Your estimated repair cost is:" />
        <div className="mx-auto box_price mt-5">
          <span className="d-block pt-4 text-center size_time">{this.state.time_repair}</span>
        </div>
        <div className="text-center mt-5">
            <button onClick={() => window.location="/payment"} className="btn btn-secondary mt-3">Book appointment</button>
        </div>
        <div className="text-center mt-3 mb-5">
            <button onClick={this.confirmDent} className="btn_no_thanks mb-5">Find another time</button>
        </div>
      </React.Fragment>
    );
  }
}

export default Time_confirmation;
